import { useThree } from "@react-three/fiber";
import gsap from "gsap";
import { useCallback, useRef } from "react";
import type { Pose } from "./cameraTargets";

export const useCameraTo = (): ((
  pose: Pose,
  duration?: number,
) => Promise<void>) => {
  const camera = useThree((s) => s.camera);
  const tweens = useRef<gsap.core.Tween[]>([]);

  return useCallback(
    (pose: Pose, duration = 1.3): Promise<void> => {
      tweens.current.forEach((t) => t.kill());
      tweens.current = [];
      return new Promise<void>((resolve) => {
        let remaining = 2;
        const done = (): void => {
          remaining -= 1;
          if (remaining === 0) resolve();
        };
        const tp = gsap.to(camera.position, {
          x: pose.pos[0],
          y: pose.pos[1],
          z: pose.pos[2],
          duration,
          ease: "power2.out",
          onComplete: done,
        });
        const tr = gsap.to(camera.rotation, {
          x: pose.rot[0],
          y: pose.rot[1],
          z: pose.rot[2],
          duration,
          ease: "power2.out",
          onComplete: done,
        });
        tweens.current = [tp, tr];
      });
    },
    [camera],
  );
};
